import coverImg from "assets/images/v140/cover.webp"

export const v140Config = {
  cover: {
    en: coverImg,
  },
}
